module.exports = __webpack_public_path__ + "3a12e816b758b4d91e58f0cd207dc137.png";